import { render, staticRenderFns } from "./SuperkidVolunteerRegistration.vue?vue&type=template&id=f47a64e2&scoped=true&"
import script from "./SuperkidVolunteerRegistration.vue?vue&type=script&lang=js&"
export * from "./SuperkidVolunteerRegistration.vue?vue&type=script&lang=js&"
import style0 from "./SuperkidVolunteerRegistration.vue?vue&type=style&index=0&id=f47a64e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47a64e2",
  null
  
)

export default component.exports